// extracted by mini-css-extract-plugin
export default {"photoPost":"photoPost_photoPost__8ylSQ","file":"photoPost_file__6S-By","preview":"photoPost_preview__IWShq"};